import TargetLink from "@/components/TargetLink";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import styles from "@/styles/Row.module.scss";
import { useMemo } from "react";

export default function AdvertListRow({ item }) {
  const target = useMemo(() => {
    if (item.targetBlank) {
      return "_blank";
    } else {
      return "_self";
    }
  }, [item]);
  return (
    <div className={classnames(styles.container, styles.list)}>
      <div className={styles.inner}>
        <div className={styles.artwork}>
          <CardArtwork
            item={item}
            className={styles.artworkInner}
            href={item.url}
            linkAttr={{ target, rel: "noopener noreferrer" }}
          />
        </div>
        <div className={styles.info}>
          <h4 className={styles.title}>
            <TargetLink href={item.url} blank={item.targetBlank}>
              {item.name}
            </TargetLink>
          </h4>
          <p className={styles.description}>{item.description}</p>
        </div>
      </div>
    </div>
  );
}
